import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from "styled-components";
import bg from "../../assets/images/bg.png";

const query = graphql`
  {
    allFile(
      filter: { relativeDirectory: { eq: "insurance" }, ext: { ne: "svg" } }
    ) {
      nodes {
        name
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
    }
  }
`;

const Insurance = ({ title = "Tenemos el seguro que necesitas" }) => {
  const data = useStaticQuery(query);
  const nodes = data.allFile.nodes;
  return (
    <Wrapper>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="text-center">{title}</h1>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-sm-6 col-md-4 col-lg-3">
            <div className="card">
              <div className="card-header">Automóvil</div>
              <div className="card-body">
                <GatsbyImage image={getImage(nodes[0])} alt="automovil" />
                <Link to="/product-detail" className="btn btn-warning">
                  Cotizar
                </Link>
                <p>Conoce más…</p>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <div className="card">
              <div className="card-header">Accidentes personales</div>
              <div className="card-body">
                <GatsbyImage
                  image={nodes[1].childImageSharp.gatsbyImageData}
                  alt="accidentes"
                />
                <a href="#" className="btn btn-warning">
                  Cotizar
                </a>
                <p>Conoce más…</p>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <div className="card">
              <div className="card-header">Hogar</div>
              <div className="card-body">
                <GatsbyImage
                  image={nodes[2].childImageSharp.gatsbyImageData}
                  alt="hogar"
                />
                <a href="#" className="btn btn-warning">
                  Cotizar
                </a>
                <p>Conoce más…</p>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <div className="card">
              <div className="card-header">Salud</div>
              <div className="card-body">
                <GatsbyImage
                  image={nodes[3].childImageSharp.gatsbyImageData}
                  alt="salud"
                />
                <a href="#" className="btn btn-warning">
                  Cotizar
                </a>
                <p>Conoce más…</p>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <div className="card">
              <div className="card-header">Responsabilidad civil</div>
              <div className="card-body">
                <GatsbyImage
                  image={nodes[4].childImageSharp.gatsbyImageData}
                  alt="civil"
                />
                <a href="#" className="btn btn-warning">
                  Cotizar
                </a>
                <p>Conoce más…</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Insurance;

export const Wrapper = styled.section`
  padding: 80px 0;
  position: relative;
  background-image: url(${bg});
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  @media (min-width: 1200px) {
    .col-lg-3 {
      flex: 0 0 20%;
      max-width: 20%;
    }
  }

  @media (max-width: 767px) {
    padding: 50px 0;
  }

  h1 {
    color: #5268c2;
    font-size: 45px;
    font-weight: 600;

    @media (max-width: 767px) {
      font-size: 30px;
    }
  }

  .card {
    border-radius: 35px;
    box-shadow: 5px 5px 10px #00000029;
    border: none;
    margin-top: 30px;

    .card-header {
      border-radius: 35px 35px 0px 0px;
      background: #5268c2;
      color: #fff;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      line-height: 21px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 14px 25px;
      min-height: 72px;
    }

    .card-body {
      text-align: center;
      padding: 15px;

      img {
        width: 100%;
        object-fit: cover;
        @media (min-width: 576px) {
          height: 100px;
        }
      }
    }
    p {
      margin-top: 15px;
      color: #5268c2;
      font-size: 14px;
      margin-bottom: 0;
    }

    .btn {
      padding: 4px 40px;
      margin-top: 15px;
      width: 55%;
      @media (min-width: 576px) {
        width: 90%;
      }
    }
  }
`;
